import { API_NEW } from "src/API";
import { WopiSettingsResponseType, EmbeddedParamsResponseType } from "./types";

/** АПИ-класс с функциями запросами к сервису */
 class API extends API_NEW {

	/** Запрос на настройки WOPI */
	static getSettings = async (): Promise<WopiSettingsResponseType> => {
		const res = await this.onRequest<WopiSettingsResponseType>({ url: window.host + "/wopi/GetSettings" });
		if ( res.statusCode === 200 ) {
			return res.result!;
		}
		return {
			...res,
			result: undefined
		}
	};

	/** Запрос за параметрами предпросмотра */
	static getPreviewParams = async ( fileId: string, attachmentId: string ): Promise<EmbeddedParamsResponseType> => {
		const qs = new URLSearchParams({
			fileId: attachmentId,
			deloid: fileId,
			action: "embedview"
		}).toString();
		const res = await this.onRequest<EmbeddedParamsResponseType>({ 
			url: `${window.host}/wopi/GetEmbeddedParams?${qs}`
		});
		if ( res.statusCode === 200 ) {
			return res.result!;
		}
		return {
			...res,
			result: undefined
		};
	};
};

export default API;
